/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

import utilityService from './utility.service';
import AppConst from '../constants/app.constant';
import EventConst from '../constants/event.constant';
import Emitter from '../bus';
// eslint-disable-next-line import/no-cycle
import router from '../router';

const tourService = () => {
  const contents = {};
  let routeName = '';
  let toursteps = [];
  contents.setTourSteps = function f1() {
    const vm = this;
    routeName = router.currentRoute.value.name;
    toursteps = utilityService.setTourSteps(vm, router.currentRoute.value.name);
    toursteps = vm.toursteps;
  };
  contents.fireshowSlider = (currentStep) => {
    let borderRadius = 8;
    if (routeName === 'app.gridview' && currentStep === 3) {
      Emitter.emit(EventConst.tourEvent);
    } else if (routeName === 'app.leafletmapview' && currentStep === 1) {
      Emitter.emit(EventConst.tourEvent);
    } else if (routeName === 'app.routeprofile' && currentStep === 7) {
      Emitter.emit(EventConst.tourEvent);
    } else {
      Emitter.emit(EventConst.tapped_outside);
      borderRadius = null;
    }
    return borderRadius;
  };
  contents.disablePointerEvents = () => {
    const myElements = document.querySelectorAll('body .hydrated');
    myElements.forEach((value) => {
      value.style.pointerEvents = 'none';
    });
  };
  contents.enablePointerEvents = () => {
    const myElements = document.querySelectorAll('body .hydrated');
    myElements.forEach((value) => {
      value.style.pointerEvents = null;
    });
  };
  contents.onStart = () => {
    contents.setTourSteps();
    contents.setOverlay(0);
  };
  contents.onNext = (currentStep) => {
    const borderRadius = contents.fireshowSlider(currentStep);
    setTimeout(
      () => {
        contents.setOverlay(currentStep + 1, borderRadius);
      },
      AppConst.tourOverlayDelayTimeout,
    );
  };
  contents.onPrevious = (currentStep) => {
    const borderRadius = contents.fireshowSlider(currentStep - 2);
    setTimeout(
      () => {
        contents.setOverlay(currentStep - 1, borderRadius);
      },
      AppConst.tourOverlayDelayTimeout,
    );
  };
  contents.onStop = () => {
    contents.hideOverlay();
    Emitter.emit(EventConst.tapped_outside);
  };
  contents.setOverlay = (currentStep, borderRadius = 4) => {
    const divID = toursteps[currentStep].target;
    const overlay = document.getElementById('tour-container-overlay');
    let myDiv;
    let overlayBox;
    if (divID.charAt(0) === '.') {
      myDiv = document.getElementsByClassName(divID.substring(1));
      if (myDiv && myDiv.length > 0) {
        overlayBox = myDiv[0].getBoundingClientRect();
      }
    } else if (divID.charAt(0) === '#') {
      myDiv = document.getElementById(divID.substring(1));
      if (myDiv) {
        overlayBox = myDiv.getBoundingClientRect();
      }
    }
    if (overlay && overlayBox) {
      overlay.style.borderRadius = `${borderRadius}px`;
      overlay.style.width = `${overlayBox.width}px`;
      overlay.style.height = `${overlayBox.height}px`;
      overlay.style.marginTop = `${overlayBox.top}px`;
      overlay.style.marginLeft = `${overlayBox.left}px`;
      overlay.style.display = 'block';
      contents.disablePointerEvents();
    }
  };
  contents.hideOverlay = () => {
    const overlay = document.getElementById('tour-container-overlay');
    if (overlay) {
      overlay.style.display = 'none';
      contents.enablePointerEvents();
    }
  };
  return contents;
};
export default tourService();
